export function roundToTwoDecimalPlaces(value: number): number {
  return Math.ceil(parseFloat((value * 100).toFixed(2))) / 100;
}

export function floorToTwoDecimalPlaces(value: number): number {
  return Math.floor(parseFloat((value * 100).toFixed(2))) / 100;
}
